import { render, staticRenderFns } from "./ProjectSummaryAmountsView.vue?vue&type=template&id=44c2defa&scoped=true&"
import script from "./ProjectSummaryAmountsView.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryAmountsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c2defa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VLayout,VSubheader,VToolbar,VToolbarTitle})
